<template>

<button class="btn btn-primary" v-html="buttonText" data-bs-toggle="modal" :data-bs-target="'#Modal' + TbtnId"></button>



<div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId" data-bs-backdrop="false">
  <div class="modal-dialog" >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ type }} 전송</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <input type="text" class="form-control" v-model="Tphone" placeholder="수신 전화번호" :disabled="disableModifyPhone" />
        <input type="text" class="form-control" v-model="Ttitle" placeholder="제목" :disabled="disableModifyText" />
        <textarea v-model="Ttext" class="form-control" placeholder="내용" :disabled="disableModifyText"></textarea>
        현재 {{ msgLength }}바이트/80 입니다. (URL은 단축되어 개당 20바이트로 계산)<br>
        SMS 모드에서는 제목은 전송되지 않습니다.
     <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" v-on:click="send()" :class="{disabled: msgLength > 80}">전송</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
      </div>

      </div>
    </div>
  </div>
</div>


</template>

<script>
import axios from 'axios';
export default {
  name: "ims",
  props: {
    targetStudent: Number,
    p_bizId: Number,
    studentId: Number,
    title: String,
    text: String,
    type: {
      type: String,
      default: "SMS"
    },
    service: String,
    phone: String,
    disableModifyText: String, // title도 같이 제한걸림
    disableModifyPhone: String,
    reqRef: String,
    buttonText: {
        type: String,
        default: "<i class=\"bi bi-chat-dots\"></i> SMS 전송"
    },
    btnId: String
  },
  data: function () {
    return {
        Ttitle: this.title,
        Ttext: this.text,
        Tphone: this.phone,
        TbtnId: this.btnId || Math.random().toString().substr(2,5)
    }
   },
   methods: {
       send(){
                axios.post('/ims/' + this.Tphone, {
                    title: this.Ttitle,
                    text: this.Ttext,
                    dstUser: this.targetStudent,
                    type: this.type,
                    service: this.service,
                    ref: this.reqRef,
                    p_bizId: this.p_bizId,
                    studentId: this.studentId,
                }).then((response) => {
                  if(response.data.error){
                                        $.notify({
                    // options
                    message: response.data.error
                    }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                    });
                  } else {
                                                            $.notify({
                    // options
                    message: "전송에 성공하였습니다"
                    }, {
                    // settings
                    type: 'success',
                    z_index: 9999
                    });
                  }
                    
                    
                })
       }, 
       urlReplace(str){
        let match = str.match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
        let final=str;
        if(!match) return str;
        match.map(url=>{
            final=final.replace(url,"00000000000000000000")
        })
        return final;
      } 
   },
   computed: {
    // 계산된 getter
    msgLength: function () {
      // `this` 는 vm 인스턴스를 가리킵니다.
      return new Blob([this.urlReplace(this.Ttext)]).size;
    }
  }
};
</script>